import React from 'react';
import {StyledPrestaTest} from '../styles'

function PriceTable({categoryData, categoryName}){
    return(
        <StyledPrestaTest id="tarifs">
          <div className={`presta-titre-${categoryName}`}>
              <div className="presta-titre">
                <h3>{categoryData.title}</h3>
              </div>

              {Object.keys(categoryData.data).map((genre) => (
                  <div className={`${genre} content`} key = {genre}>
                    <div className="genre">
                      <h5>{genre.toUpperCase()}</h5>
                    </div>

                    <div className="data-content">
                      {categoryData.data[genre].map((item, index) => (
                      <React.Fragment key={index}>
                          <div className="row">
                            <div className="prestation">
                                <p>{item.prestation.map((v, i) => <p key={i}>{v}</p>)}</p>
                            </div>
                            <div className="details">
                                {item.variations.map((v, i) => <p key={i}>{v.details}</p>)}
                            </div>
                            <div className="prix">
                                {item.variations.map((v, i) => <p key={i}>{v.prix}</p>)}
                            </div>
                            <div className="duree">
                                {item.variations.map((v, i) => <p key={i}>{v.duree}</p>)}
                            </div>
                          </div>
                          {index < categoryData.data[genre].length - 1 && <hr className="separator" />}
                      </React.Fragment>
                      ))}
                    </div>
                  </div>
              ))}
          </div>
        </StyledPrestaTest>
    );
}

export default PriceTable;